module.exports = __webpack_public_path__ + "static/media/momskart.20a387d0.webp";